'use strict'

import algoliasearch from 'algoliasearch'

export const search = (() => {
  const appID = document.head.querySelector('meta[name="Algolia-Application-Id"]')?.content
  const apiKey = document.head.querySelector('meta[name="Algolia-Api-Key"]')?.content
  const indexName = 'production_products'

  const MAX_HITS = 10
  const DEBOUNCE_TIMEOUT = 400
  const MIN_QUERY_LENGTH = 3

  const client = algoliasearch(appID, apiKey)
  const index= client.initIndex(indexName)

  let debounceTimer

  const debounce = (input) => {
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      const query = input.value.trim()
      if(query && query.length >= MIN_QUERY_LENGTH) {
        showResults(input)
        searchProducts(input)
      } else {
        hideResults(input)
      }
    }, DEBOUNCE_TIMEOUT)
  }

  const showResults = (input) => {
    const resultsContainer = input.closest('form').querySelector('.header__search__results')

    if(!resultsContainer) return

    resultsContainer.style.display = 'block'
  }

  const hideResults = (input) => {
    const resultsContainer = input.closest('form').querySelector('.header__search__results')

    if(!resultsContainer) return

    resultsContainer.style.display = 'none'
  }

  const searchProducts = async (input) => {
    // Get the form
    const form = input.closest('form')

    if(!form) return

    // Get the results container
    const resultsContainer = form.querySelector('.header__search__results')

    if(!resultsContainer) return

    // Add searching class modifier
    resultsContainer.classList.add('header__search__results-searching')

    const query = input.value.trim()

    index.search(query, {
      hitsPerPage: MAX_HITS,
    }).then(({hits, nbHits}) => {
      // Draw the search results
      drawResults(form, hits)
      // Show the read more link
      showMore(form, nbHits, query)
    }).finally(() => {
      // Remove searching class modifier
      resultsContainer.classList.remove('header__search__results-searching')
    })
  }

  const drawResults = (form, hits) => {
    const resultsContainer = form.querySelector('.header__search__results')

    if(!resultsContainer) return

    const hitsContainer = resultsContainer.querySelector('.header__search__results__items')

    if(!hitsContainer) return

    const template = resultsContainer.querySelector('template')

    if(!template) return

    clearResults(form)

    hits.forEach(hit => {
      const clone = document.importNode(template.content, true)

      clone.querySelector('.header__search__results__item__title').textContent = hit.title

      const price = hit.salePrice ?? hit.defaultPrice
      if(price) {
        clone.querySelector('.header__search__results__item__price').textContent = `$${price}`
      }

      
      clone.querySelector('.header__search__results__item__image img').src = hit.Product_Image
      clone.querySelector('.header__search__results__item__link').href = `/products/${hit.slug}`

      hitsContainer.appendChild(clone)
    })
  }

  const showMore = (form, nbHits, query = '') => {
    const noResults = form.querySelector('.header__search__results__empty')
    if(noResults) {
      if(nbHits > 0) {
        noResults.style.display = 'none'
      } else {
        noResults.style.display = 'block'
      }
    }
    
    const showMore = form.querySelector('.header__search__results__more')
    if(!showMore) return

    if(nbHits <= MAX_HITS) {
      showMore.style.display = 'none'
    } else {
      showMore.style.display = 'block'
      showMore.href = `/lightening-search?query=${query}`
    }
  }

  const clearResults = (input) => {
    const form = input.closest('form')

    showMore(form, 0)

    const hitsContainer = form.querySelector('.header__search__results__items')
    
    if(!hitsContainer) return
    
    hitsContainer.innerHTML = ''
  }

  const init = () => {
    const searchInputs = document.querySelectorAll('.header__search input[name="query"]')

    searchInputs.forEach(searchInput => {
      searchInput.addEventListener('keyup', () => debounce(searchInput))

      const form = searchInput.closest('form')

      if(!form) return

      // If something wrong with Algolia keys make the form hidden
      if(!appID || !apiKey) {
        form.style.display = 'none'
      }  

      // Add a submit event listener to the form to trigger the search when pressing enter key
      form.addEventListener('submit', event => {
        event.preventDefault()
        debounce(searchInput)
      })
    })
  }

  return {
    init,
  }
})()
